module.exports = __webpack_public_path__ + "img/website-service-03.3098cb9c.png";